module.exports = __webpack_public_path__ + "static/media/input_l.05bb4e11.png";